module.exports = __webpack_public_path__ + "static/media/no-notification-icon.71582828.svg";